function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

export default {
  name: 'SliderHandle',
  // Don't use mixins
  props: {
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    value: {
      type: Number,
      default: 0
    },
    disabled: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Number,
      default: 0
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style: function style() {
      var vertical = this.vertical,
          offset = this.offset;
      return vertical ? {
        bottom: "".concat(offset, "%")
      } : {
        left: "".concat(offset, "%")
      };
    },
    bindAttrs: function bindAttrs() {
      var $attrs = this.$attrs,
          min = this.min,
          max = this.max,
          value = this.value,
          disabled = this.disabled;
      return _objectSpread({}, $attrs, {
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': !!disabled
      });
    }
  },
  methods: {
    focus: function focus() {
      var handleRef = this.$refs.handleRef;

      if (handleRef) {
        handleRef.focus();
      }
    },
    blur: function blur() {
      var handleRef = this.$refs.handleRef;

      if (handleRef) {
        handleRef.blur();
      }
    },
    onFocus: function onFocus(e) {
      this.$emit('focus', e);
    },
    onBlur: function onBlur(e) {
      this.$emit('blur', e);
    }
  },
  render: function render() {
    var h = arguments[0];
    var style = this.style,
        bindAttrs = this.bindAttrs,
        onFocus = this.onFocus,
        onBlur = this.onBlur;
    return h("div", {
      "ref": "handleRef",
      "style": style,
      "attrs": _objectSpread({}, bindAttrs),
      "on": _objectSpread({}, {
        focus: onFocus,
        blur: onBlur
      })
    });
  }
};